






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatTimeStr } from '@/utils/other';

type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;

@Component({
  filters: {
    formatTimeStr,
  },
})
export default class RequirementModule extends Vue {
  @Prop({required: true}) private requirement!: IRequirementInfo;
  get modules() {
    return this.requirement ? this.requirement.modules : [];
  }
  private viewModule(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
}
